"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _AdpAnalytics_instances, _AdpAnalytics_autoCapturePageIfNeeded, _AdpAnalytics_postEventHook, _AdpAnalytics_postEventHookByEventType_get, _AdpAnalytics_setupSession, _AdpAnalytics_setUpContext, _AdpAnalytics_setupFacetFilterIfEnabled, _AdpAnalytics_setupUser, _AdpAnalytics_setupGeoIfEnable, _AdpAnalytics_setupHostProductInfoIfEnable, _AdpAnalytics_send, _AdpAnalytics_trackLinkFormArgs, _AdpAnalytics_parsePageArgs, _AdpAnalytics_addNewComponent;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Adp = exports.AdpAnalytics = void 0;
/* eslint-disable class-methods-use-this */
/* eslint-disable no-param-reassign */
/**
 * ADP Analytics Javascript Web SDK Module
 * @author Micaela Lopez <micaela.lopez@autodesk.com>
 */
const superstruct_1 = require("superstruct");
const axios_1 = require("axios");
const Events_1 = require("./Events");
const Common_1 = require("./Common");
const Logger_1 = __importStar(require("./Logger"));
const CommonTypes_1 = require("./types/CommonTypes");
const FacetTypes_1 = require("./types/FacetTypes");
const FacetFilterService_1 = require("./FacetFilterService");
const SessionService_1 = require("./SessionService");
const UserService_1 = require("./UserService");
const RestService_1 = require("./RestService");
const LocalDataService_1 = require("./LocalDataService");
const MessageBuilderService_1 = require("./MessageBuilderService");
const ContextService_1 = require("./ContextService");
const UserConsentStatus_1 = require("./UserConsentStatus");
const ClickCaptureService_1 = require("./ClickCaptureService");
const UserConsentDialogService_1 = require("./UserConsentDialogService");
const CookieService_1 = require("./CookieService");
const SetHostProduct_1 = require("./SetHostProduct");
const UrlUtils_1 = require("./UrlUtils");
const Utils_1 = require("./Utils");
/**
 * ***Notes***
 *
 * - 🔥 New
 * - ✨ Modified
 * - 🛠 Fixed
 *
 * ### v3.9
 *
 * - Ⓜ️ 🔥️ {@link entitlement}
 *
 * ### v3.8
 *
 * - Ⓜ️ 🔥️ {@link setProductReferrer}
 * - Ⓜ️ 🔥️ {@link getURLWithProductReferrer}
 * - Ⓜ️ 🛠️ {@link enableHostProductData} *(Fix `product_meta.ADDIN_PARENT_ID` & `product_meta.ADDIN_PARENT_SESSIONID` keys)*
 *
 * ### v3.7.1
 *
 * - Ⓜ️ ✨ {@link showUserConsentDialog} *(Documentation updated)*
 *
 * ### v3.6
 *
 * - Ⓜ️ ✨ {@link identify}
 * - Ⓜ️ ✨ {@link showUserConsentDialog}
 *
 * ### v3.5
 *
 * - Ⓜ️ 🔥 {@link group}
 *
 * ### v3.4
 *
 * - Ⓜ️ 🔥 {@link enableAutoCaptureClickEvents}
 *
 * ### v3.3
 *
 * - Ⓜ️ 🔥 {@link enableFacetBasedFiltering}
 * - Ⓜ️ 🔥 {@link loadUserConsentPreferences}
 * - Ⓜ️ 🔥 {@link setCurrentUserConsentPreferences}
 *
 * ### v3.2
 *
 * - Ⓜ️ 🔥 {@link setSessionId}
 *
 * ### v3.1
 *
 * - Ⓜ️ 🔥 {@link getCurrentUserConsentCopy}
 * - Ⓜ️ 🔥 {@link getCurrentUserConsentPreferences}
 * - Ⓜ️ 🔥 {@link setCurrentUserConsentPreferences}
 * - Ⓜ️ ✨ {@link getUserConsentCopy}
 * - Ⓜ️ ✨ {@link getUserConsentPreferences}
 *
 */
class AdpAnalytics {
    /** @internal */
    constructor(
    /** @internal */
    contextService, facetFilterService, userService, messageBuilderService, sessionService, restService, clickCaptureService, userConsentDialog) {
        _AdpAnalytics_instances.add(this);
        this.contextService = contextService;
        this.facetFilterService = facetFilterService;
        this.userService = userService;
        this.messageBuilderService = messageBuilderService;
        this.sessionService = sessionService;
        this.restService = restService;
        this.clickCaptureService = clickCaptureService;
        this.userConsentDialog = userConsentDialog;
        this.loadCalled = false;
        this.setupPromise = null;
    }
    /**
     * Set the custom device ID. the Web SDK will generate an ID by default, using information from the browser's user agent, screen, and timezone.
     * @param id - Custom device ID
     * @category Configuration
     */
    setDeviceId(id) {
        this.contextService.context.device_id = id;
        return this;
    }
    /**
     * Enable to log useful debugging information.
     * @category Configuration
     */
    enableDebug() {
        this.contextService.context.config.debug = true;
        return this;
    }
    /**
     * Set the environment. The default environment is determined by the environment of the NPM/CDN Web SDK package.
     * @param env - Environment name
     * @category Configuration
     */
    setEnv(env) {
        this.contextService.context.config.env = env;
        return this;
    }
    /**
     * Enable to automatically capture click events for Element that have the `adp-click` attribute.
     * The event will be associated with the nearest parent element that has the `adp-click` attribute.
     * If no such element is found, the click event is discarded.
     *
     * Maps the following Element attributes to the component facet:
     * - `component_id`: `adp-component-id` || `id`.
     * - `component_name`: `adp-component-name` || (`alt` | `name` | `value` | `textContent`); The exact property depends on the tagName of the element. e.g. `value` only applies to input[type=`submit|reset`].
     * - `component_type`: `adp-component-type` || `tagName`.
     * - `component_attributes`: `adp-component-attribute-[key]=[value]`, where `key` and `value` forms the respective key-value pair in the object.
     * - `component_metrics`: `adp-component-metric-[key]=[value]`, where `key` and `value` forms the respective key-value pair in the object.
     *
     * @remarks New in v3.4
     * @category Configuration
     */
    enableAutoCaptureClickEvents() {
        this.contextService.context.config.captureDocumentClickEvents = true;
        return this;
    }
    /**
     * Enable to use the facet-based filtering feature. The Web SDK will download facet-based filtering file and apply its rules to decide if it should send an tracking event or not.
     * @remarks New in v3.3
     * @category Configuration
     */
    enableFacetBasedFiltering() {
        this.contextService.context.config.facetBasedFiltering = true;
        return this;
    }
    /**
     * Enable to collect geolocation data. The browser may request user permission to collect it.
     * @category Configuration
     */
    enableGeoData() {
        this.contextService.context.config.geoData = true;
        return this;
    }
    /**
     *  Enable to retrieve the host product information (`product_id`, `session_id`) as (`product_meta.ADDIN_PARENT_ID`, `product_meta.ADDIN_PARENT_SESSIONID`).
     *  @category Configuration
     *  @remarks Changed in v3.8
     */
    enableHostProductData() {
        this.contextService.context.config.hostProductData = true;
        return this;
    }
    /**
     * Disable to prevent data from being sent to the server, useful for debugging purposes.
     * @category Configuration
     */
    disableSendEvent() {
        this.contextService.context.config.sendEvent = false;
        return this;
    }
    /**
     * Set the session duration with a positive integer as hour.
     *
     * @param duration.hour
     * Default value is 1 hour.
     * Setting it to 0 will make the session never expire.
     * The Web SDK supports durations up to hours.
     * Floating point or negative values will revert to the default.
     *
     * @category Configuration (Session life-cycle)
     */
    setSessionTimeout(duration) {
        let { hour } = duration;
        try {
            (0, superstruct_1.assert)(hour, SessionService_1.ValidDurationHour);
        }
        catch (e) {
            hour = 1;
        }
        finally {
            this.contextService.context.config.sessionDuration.hour = hour;
        }
        return this;
    }
    /**
     * Specifies the session ID that will be assigned to each event data.
     * Web SDK will reuse this session ID even when the session has expired and a new session has started.
     * Must be called before {@link load}.
     *
     * @param id - The session ID which is used for all subsequent sessions
     *
     * @remarks New in v3.2
     * @category Configuration (Session life-cycle)
     */
    setSessionId(id) {
        if (this.loadCalled) {
            Logger_1.default.warn("Session ID can only be set before Web SDK is initialized");
            return this;
        }
        const trimmedId = id.trim();
        if (!trimmedId) {
            Logger_1.default.warn("Session ID could not be initialized with an empty string");
            return this;
        }
        this.contextService.context.config.sessionId = trimmedId;
        return this;
    }
    /**
     * @deprecated since v3.3.0. The default configuration is disabled already, so we don't really need this method.
     * @category Configuration (deprecated)
     */
    disableDebug() {
        this.contextService.context.config.debug = false;
        return this;
    }
    /**
     * @deprecated since v3.3.0. The default configuration is disabled already, so we don't really need this method.
     * @category Configuration (deprecated)
     */
    disableGeoData() {
        this.contextService.context.config.geoData = false;
        return this;
    }
    /**
     * @deprecated since v3.3.0. The default configuration is disabled already, so we don't really need this method.
     * @category Configuration (deprecated)
     */
    disableHostProductData() {
        this.contextService.context.config.hostProductData = false;
        return this;
    }
    /**
     * @deprecated since v3.3.0. The default configuration is enabled already, so we don't really need this method.
     * @category Configuration (deprecated)
     */
    enableSendEvent() {
        this.contextService.context.config.sendEvent = true;
        return this;
    }
    /**
     * {@link setUserConsentPreferences} will take precedence over this method.
     * Once {@link setUserConsentPreferences} is called, any callbacks associated with this method will no longer be called!
     *
     * Sets the user Oxygen token provider callback.
     * Web SDK will invoke this callback each time to ensure the receipt of a valid Oxygen token rather than an expired one.
     * That's why it is a `callback` instead of a `Promise<string>`.
     *
     * @deprecated since v3.1.0
     * @category User & User Privacy (deprecated)
     */
    setUserTokenProvider(callback) {
        this.contextService.context.callback.retrieveUserToken = callback;
        return this;
    }
    /**
     * {@link setUserConsentPreferences} will take precedence over this method.
     * Once {@link setUserConsentPreferences} is called, any callbacks associated with this method will no longer be called!
     *
     * @deprecated since v3.1.0
     * @category User & User Privacy (deprecated)
     */
    setUserConsentDialogBuilder(callback) {
        this.contextService.context.callback.buildUserConsentDialog = callback;
        return this;
    }
    /**
     * Attaches the details in the provided product facet to the current context as a referrer product.
     * @param {object} referrer - An object that is a variation of a subset of the product facet. The product ID, name, and build ID will be used to populate the REFERRER details
     * @param referrer.id - The product ID of the previous product, e.g. the APS client ID
     * @param referrer.name - The name of the previous product
     * @param referrer.sessionId - The session ID of the previous product
     * @param referrer.buildId - (Optional) The build ID of the previous product
     * @remarks New in v3.8
     * @category Configuration (Calling product lineage)
     */
    setProductReferrer(referrer, type = "url") {
        if (!(0, Utils_1.validateAndLogErrors)(referrer, (0, superstruct_1.object)({
            id: (0, superstruct_1.nonempty)((0, superstruct_1.string)()),
            name: (0, superstruct_1.nonempty)((0, superstruct_1.string)()),
            buildId: (0, superstruct_1.optional)((0, superstruct_1.nonempty)((0, superstruct_1.string)())),
            sessionId: (0, superstruct_1.nonempty)((0, superstruct_1.string)()),
        }))) {
            return;
        }
        const { id, name, buildId, sessionId } = referrer;
        this.contextService.context.facets.product.meta = Object.assign(Object.assign(Object.assign({}, this.contextService.context.facets.product.meta), (buildId && { REFERRER_VERSION: buildId })), { REFERRER_ID: id, REFERRER_NAME: name, REFERRER_SESSION: sessionId, REFERRER_TYPE: type });
    }
    /**
     * Appends the current product information to the URL's search parameters
     * The following parameters will be appended:
     *
     * adp_referrer_id: product_id from the product facet in the current context
     *
     * adp_referrer_name: product_name from the product facet in the current context
     *
     * adp_referrer_session: session_id from the current context
     *
     * adp_referrer_version: product_build_id from the product facet in the current context
     *
     * @param url - The base URL to append the search parameters
     * @returns URL with subset of current product information appended as search parameters, or undefined if invalid URL was provided or if the SDK is not loaded
     * @remarks New in v3.8
     * @category Utility
     */
    getURLWithProductReferrer(url) {
        if (!this.loadCalled)
            return undefined;
        if (!(0, superstruct_1.validate)(url, (0, superstruct_1.union)([(0, superstruct_1.string)(), (0, superstruct_1.instance)(URL)]))) {
            return undefined;
        }
        try {
            return (0, UrlUtils_1.appendProductToURL)(url, this.contextService.context.facets.product, this.contextService.context.session_id);
        }
        catch (e) {
            Logger_1.default.error(Common_1.ERROR_MESSAGE.invalidArguments, e.message);
            return undefined;
        }
    }
    /**
     * Returns the device ID.
     */
    getDeviceId() {
        return this.contextService.context.device_id;
    }
    /**
     * Attaches one or more callback functions to a specific hook type which are supposed to be executed when a specified hook is triggered.
     *
     * @param hook - The type of hook to attach the callback to. This can be general "track" or a specific event identifier like "CLICK_COMPONENT"...
     * @param callback - The callback function to be executed on the hook
     *
     * @example
     * adp.on("ready", (context) => {
     *   // Your code to intercept when Web SDK is ready.
     * });
     *
     * adp.on("ready", (context) => {
     *   // Your code to intercept when Web SDK is ready.
     * });
     *
     * adp.on("CLICK_COMPONENT", (context, message) => {
     *   // Your code to intercept when Web SDK tracks a CLICK_COMPONENT event.
     * });
     *
     */
    on(hook, callback) {
        var _a;
        const { eventHooks } = this.contextService.context.callback;
        ((_a = eventHooks[hook]) !== null && _a !== void 0 ? _a : (eventHooks[hook] = [])).push(callback);
        return this;
    }
    /**
     * Fetches the unnamed user consent information if omitting input `userToken`.
     * Fetches the named user consent information if specifying input `userToken`.
     * Then it will update the user information and user consent information in the {@link AdpAnalytics} instance.
     *
     * Requires {@link load} to be called first since the payload is locale specific.
     * If the product locale is unspecified, the Web SDK defaults to the window locale or `en` if there are issues.
     *
     * @param userToken - User Oxygen token, omit for unnamed user
     *
     * @returns
     * The promise that resolves either an `Error` if Web SDK fails to update its user state or an object containing the current user consent status, user consent copy and user consent preferences.
     * Action can be decided based on the status code. Generally, no further user consent action is required if the user has opt-in to tracking.
     *
     * @example
     * // Unnamed User
     * const result = await adp.loadUserConsentPreferences();
     * if ('status' in result && result.status.code !== result.status.USER_OPT_IN) {
     *   // handle requesting user's input to set user consent
     * }
     *
     * @example
     * // Named User
     * const auth = new AuthClient(options);
     * const token = getAccessTokenSilently();
     * const result = await adp.loadUserConsentPreferences(token);
     * if ('status' in result && result.status.code !== result.status.USER_OPT_IN) {
     *   // handle requesting user's input to set user consent
     * }
     *
     * @remarks New in v3.3
     * @category User & User Privacy
     */
    loadUserConsentPreferences(userToken) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.contextService.taskQueue.add(() => __awaiter(this, void 0, void 0, function* () {
                var _a;
                try {
                    Logger_1.default.debug("BEGIN Load User Consent", this.contextService.context);
                    if (!this.loadCalled) {
                        return new Error(Common_1.ERROR_MESSAGE.adpNotLoaded);
                    }
                    const tokenInfo = yield this.userService.parseTokenInfo(userToken);
                    if (tokenInfo instanceof Error) {
                        Logger_1.default.error(tokenInfo.message);
                        return tokenInfo;
                    }
                    const userConsent = yield this.userService.loadUser(tokenInfo);
                    const { consentCopy, preferences } = userConsent;
                    const status = UserConsentStatus_1.UserConsentStatus.from(userConsent);
                    (_a = this.contextService.context.callback.eventHooks.user_consent) === null || _a === void 0 ? void 0 : _a.forEach((hook) => {
                        hook(this.contextService.context);
                    });
                    Logger_1.default.debug("END Load User Consent", { status, consentCopy, preferences }, this.contextService.context);
                    return {
                        status,
                        userConsentCopy: consentCopy,
                        userConsentPreferences: preferences,
                    };
                }
                catch (error) {
                    Logger_1.default.error("ERROR", "Load User Consent", error);
                    // convert Axios into instance of Error as AxiosError doesn't appear to be an instance of Error
                    if (error instanceof axios_1.AxiosError) {
                        const convertedError = new Error(error.message);
                        convertedError.stack = error.stack;
                        return convertedError;
                    }
                    return error;
                }
            }));
        });
    }
    /**
     * This initializes the Web SDK.
     * After setting all configurations, call this method to load and set up the Web SDK.
     * Call this before any tracking activity.
     *
     * @param product - An object representing the product info
     *
     * @category Initialization
     */
    load(product) {
        if (!this.loadCalled) {
            this.loadCalled = true;
            this.userService.onUserChanging = () => {
                this.contextService.context.userIntent = undefined;
                this.contextService.context.hubId = undefined;
                this.contextService.context.hubUrn = undefined;
                this.contextService.context.projectId = undefined;
                this.contextService.context.projectUrn = undefined;
            };
            const setupCaptureService = () => {
                this.clickCaptureService.connect();
            };
            this.setupPromise = (() => __awaiter(this, void 0, void 0, function* () {
                var _a;
                yield this.contextService.taskQueue.addAll([
                    __classPrivateFieldGet(this, _AdpAnalytics_instances, "m", _AdpAnalytics_setUpContext).bind(this, product),
                    __classPrivateFieldGet(this, _AdpAnalytics_instances, "m", _AdpAnalytics_setupUser).bind(this),
                    __classPrivateFieldGet(this, _AdpAnalytics_instances, "m", _AdpAnalytics_setupSession).bind(this),
                    __classPrivateFieldGet(this, _AdpAnalytics_instances, "m", _AdpAnalytics_setupGeoIfEnable).bind(this),
                    __classPrivateFieldGet(this, _AdpAnalytics_instances, "m", _AdpAnalytics_setupHostProductInfoIfEnable).bind(this),
                    __classPrivateFieldGet(this, _AdpAnalytics_instances, "m", _AdpAnalytics_setupFacetFilterIfEnabled).bind(this),
                    setupCaptureService.bind(this),
                ]);
                Logger_1.default.debug("END load Web SDK", this.contextService.context);
                (_a = this.contextService.context.callback.eventHooks.ready) === null || _a === void 0 ? void 0 : _a.forEach((cb) => cb(this.contextService.context));
            }))();
        }
        return this;
    }
    /**
     * Returns a promise that resolves when the Web SDK setup is complete.
     */
    onReady() {
        var _a;
        return (_a = this.setupPromise) !== null && _a !== void 0 ? _a : Promise.resolve();
    }
    /**
     * Returns a promise that resolves when no background tasks are active in the task queue.
     */
    onIdle() {
        return this.contextService.taskQueue.onIdle();
    }
    /** @internal */
    sendEventInQueue(eventType, facets, consentMetric) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.contextService.taskQueue.add(() => __awaiter(this, void 0, void 0, function* () {
                yield this.sendEvent(eventType, facets, consentMetric);
            }));
        });
    }
    /** @internal */
    sendEvent(eventType, facets, consentMetric) {
        var _a, _b, _c, _d, _e;
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.loadCalled) {
                const error = "You need to call adp.load() before tracking events!";
                Logger_1.default.warn(error);
                return new Error(error);
            }
            this.sessionService.refresh();
            yield __classPrivateFieldGet(this, _AdpAnalytics_instances, "m", _AdpAnalytics_setupGeoIfEnable).call(this);
            // Enable again when fixing host session changed
            // await this.#setupHostProductInfoIfEnable();
            if (!["SESSION_START", "SESSION_END"].includes(eventType)) {
                // Automatically start a session on tracking an event
                if (!this.sessionService.available) {
                    this.sessionService.startSession();
                }
                // Automatically insert session start if the event was not sent out yet
                if (!this.sessionService.trackTimestamp) {
                    Logger_1.default.debug("SESSION_START not sent. Sending SESSION_START.");
                    yield this.sendEvent("SESSION_START", undefined, consentMetric);
                }
            }
            const message = yield this.messageBuilderService.buildMsg(eventType, facets, consentMetric);
            if (message instanceof Error) {
                Logger_1.default.debug("ABORT send event", eventType, message.message);
                return message;
            }
            Logger_1.default.debug("BEGIN send event", eventType, message);
            const { eventHooks } = this.contextService.context.callback;
            (_a = eventHooks.track) === null || _a === void 0 ? void 0 : _a.forEach((cb) => cb(this.contextService.context, message));
            (_b = eventHooks[eventType]) === null || _b === void 0 ? void 0 : _b.forEach((cb) => cb(this.contextService.context, message));
            if (((_c = this.contextService.context.config) === null || _c === void 0 ? void 0 : _c.sendEvent) === false) {
                Logger_1.default.debug("SKIP send event since disableSendEvent() was set", eventType, message);
            }
            else {
                yield __classPrivateFieldGet(this, _AdpAnalytics_instances, "m", _AdpAnalytics_send).call(this, message);
            }
            (_e = (_d = __classPrivateFieldGet(this, _AdpAnalytics_instances, "a", _AdpAnalytics_postEventHookByEventType_get))[eventType]) === null || _e === void 0 ? void 0 : _e.call(_d);
            __classPrivateFieldGet(this, _AdpAnalytics_instances, "m", _AdpAnalytics_postEventHook).call(this);
            Logger_1.default.debug("END send event", eventType, message);
            return message;
        });
    }
    trackLink(...args) {
        const params = __classPrivateFieldGet(this, _AdpAnalytics_instances, "m", _AdpAnalytics_trackLinkFormArgs).call(this, "link", HTMLAnchorElement, args);
        if (!params) {
            return;
        }
        const [element, component] = params;
        element.addEventListener("click", (mouseEvent) => {
            this.track("CLICK_COMPONENT", component);
            const href = element.getAttribute("href");
            if (href &&
                element.target !== "_blank" && // The link opens in a new tab
                !mouseEvent.ctrlKey && // ctrl+click opens in a new tab on Windows (no use on macOS)
                !mouseEvent.shiftKey && // shift+click opens in a new window
                !mouseEvent.metaKey // command+click opens in a new tab on macOS (no use on Windows)
            ) {
                mouseEvent.preventDefault();
                this.onIdle().then(() => {
                    window.location.href = href;
                });
            }
        });
    }
    trackForm(...args) {
        const params = __classPrivateFieldGet(this, _AdpAnalytics_instances, "m", _AdpAnalytics_trackLinkFormArgs).call(this, "form", HTMLFormElement, args);
        if (!params) {
            return;
        }
        const [element, component] = params;
        const listener = (submitEvent) => {
            submitEvent.preventDefault();
            this.track("CLICK_COMPONENT", component);
            this.onIdle().then(() => {
                element.removeEventListener("submit", listener); // avoid infinitive loop of event listener
                element.submit();
            });
        };
        element.addEventListener("submit", listener);
    }
    /**
     * Tracks an event and sends the corresponding information for tracking events to ASE services.
     * This method operates asynchronously, creating and queuing events in the background.
     *
     * Each `eventType` (full list here {@link EVENTS}) has its equivalent `trackInfo` type which is actually a *Facet* - a field of {@link Facets}.
     * Refer to [Facets Wiki](https://wiki.autodesk.com/x/pzrfCw#ADPUsageAnalyticscoreschemaandfacets-Facets) for more info.
     *
     * | Event type   | Event scope | Facet                            | Wiki                                                                                          |
     * |--------------|-------------|----------------------------------|-----------------------------------------------------------------------------------------------|
     * | `SESSION`    | `PAGE`      | {@link PageFacet Page}           | [Page Wiki](https://wiki.autodesk.com/x/pkmmbQ)                                               |
     * | `SESSION`    | others      | {@link Facets any Facet}         | [Facets Wiki](https://wiki.autodesk.com/x/pzrfCw#ADPUsageAnalyticscoreschemaandfacets-Facets) |
     * | `PROJECT`    | any         | {@link ContentFacet Content}     | [Content Wiki](https://wiki.autodesk.com/x/Z5EiD)                                             |
     * | `DOCUMENT`   | any         | {@link ContentFacet Content}     | [Content Wiki](https://wiki.autodesk.com/x/Z5EiD)                                             |
     * | `BACKGROUND` | any         | {@link OperationFacet Operation} | [Operation Wiki](https://wiki.autodesk.com/x/W5EiD)                                           |
     * | `CLICK`      | any         | {@link ComponentFacet Component} | [Component Wiki](https://wiki.autodesk.com/x/WJEiD)                                           |
     * | `METRICS`    | any         | {@link ComponentFacet Component} | [Component Wiki](https://wiki.autodesk.com/x/WJEiD)                                           |
     * | `GESTURE`    | any         | {@link ComponentFacet Component} | [Component Wiki](https://wiki.autodesk.com/x/WJEiD)                                           |
     * | `HOVER`      | any         | {@link ComponentFacet Component} | [Component Wiki](https://wiki.autodesk.com/x/WJEiD)                                           |
     * | `VIEW`       | any         | {@link ComponentFacet Component} | [Component Wiki](https://wiki.autodesk.com/x/WJEiD)                                           |
     *
     * @template E - The generic type parameter representing the {@link EventType}
     * @param eventType - Type of the event to be tracked, full list here {@link EVENTS}
     * @param trackInfo - The additional information regarding the event to be tracked
     *
     * @example
     * // Sending a single facet object with type "Component"
     * adp.track("CLICK_COMPONENT", {
     *     id: "button-click",
     *     type: "button",
     *     name: "button",
     * });
     *
     * @category Tracking
     */
    track(eventType, trackInfo) {
        if (!(0, Utils_1.validateAndLogErrors)(eventType, (0, superstruct_1.enums)(Object.keys(Events_1.EVENTS)))) {
            return;
        }
        const facets = { [Events_1.EVENTS[eventType].facet]: trackInfo };
        if (!(0, Utils_1.validateAndLogErrors)(facets, FacetTypes_1.FacetsStruct)) {
            return;
        }
        Logger_1.default.debug("QUEUE sendEventInQueue()", eventType);
        this.sendEventInQueue(eventType, facets).then(() => Logger_1.default.debug("FINISH sendEventInQueue()"));
    }
    page(...args) {
        const page = __classPrivateFieldGet(this, _AdpAnalytics_instances, "m", _AdpAnalytics_parsePageArgs).call(this, ...args);
        if (page) {
            this.track("SESSION_PAGE", page);
        }
    }
    /**
     * Sets the user's group information as defined in Autodesk User Management.
     * Updates the user facet to include the hub and project ID.
     * At least one of hub ID or project ID must be provided, otherwise a `TypeError` will be thrown.
     *
     * This does not upload an event, it modifies subsequent events with the additional information.
     * Events uploaded after this invocation will include the project and hub ID in the user facet.
     * Multiple calls to this method will overwrite existing group information with the latest values.
     *
     * When the user is changed (e.g. change in user token, change in named/unnamed state, change by {@link loadUserConsentPreferences}), the group information is discarded.
     * It should be called only after the user token has been loaded.
     *
     * @param param - The function parameter object
     * @param param.hubId - Platform internal Hub ID
     * @param param.hubUrn - URN stored in the Project Registry for this hub
     * @param param.projectId - Source platform Project ID the customer can see or call customer support with
     * @param param.projectUrn - URN stored in the Project Registry for this project
     *
     * @example
     * const info = { hubId };
     * group(info);
     *
     * @example
     * const info = { hubId, projectId };
     * group(info);
     *
     * @remarks New in v3.5
     * @category Configuration
     */
    group(param) {
        if (!(0, superstruct_1.is)(param, CommonTypes_1.GroupOptionsStruct)) {
            Logger_1.default.error("Hub ID must be provided. Hub ID and project ID cannot be an empty string.");
            return;
        }
        const { hubId, hubUrn, projectId, projectUrn } = param;
        this.contextService.taskQueue.add(() => __awaiter(this, void 0, void 0, function* () {
            this.contextService.context.hubId = hubId;
            this.contextService.context.hubUrn = hubUrn;
            this.contextService.context.projectId = projectId;
            this.contextService.context.projectUrn = projectUrn;
        }));
    }
    /**
     * Captures the entitlement information as a "SESSION_DETAILS" event.
     * @param details - Object corresponding to the entitlements facet.
     * The "entitlement_" prefix is not needed. For more information on the facet,
     * see {@link https://wiki.autodesk.com/x/a5EiD}
     * @category Tracking
     */
    entitlement(details) {
        this.track("SESSION_DETAILS", details);
    }
    /**
     * Retrieve current user token used by the {@link AdpAnalytics} instance.
     *
     * @returns
     * A promise that resolves the user token provided by the {@link setUserConsentPreferences} method.
     * If {@link setUserConsentPreferences} was not called, it will fall back to {@link setUserTokenProvider} (deprecated) if available.
     *
     * @category User & User Privacy
     */
    retrieveUserToken() {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            const { context } = this.contextService;
            const userToken = (_b = (_a = context.tokenInfo) === null || _a === void 0 ? void 0 : _a.userToken) !== null && _b !== void 0 ? _b : (_d = (_c = context.callback).retrieveUserToken) === null || _d === void 0 ? void 0 : _d.call(_c);
            Logger_1.default.debug("User Token", userToken);
            return userToken;
        });
    }
    /**
     * Retrieve the current user consent preferences used by the {@link AdpAnalytics} instance for its tracking events.
     *
     * @remarks New in v3.1
     * @category User & User Privacy
     */
    getCurrentUserConsentPreferences() {
        return __awaiter(this, void 0, void 0, function* () {
            const preferences = this.userService.getCurrentUserConsentPreferences();
            Logger_1.default.debug("Current User Consent preferences", preferences, this.contextService.context);
            return preferences;
        });
    }
    /**
     * Set the current user consent preferences used by the {@link AdpAnalytics} instance for its tracking events.
     * This does not mutate the user information in the {@link AdpAnalytics} instance.
     * If user has not been initialized (e.g. {@link loadUserConsentPreferences} or {@link setUserConsentPreferences} was not yet called), no changes will be applied and error is logged.
     *
     * @param preferences - User consent preferences.
     *
     * @remarks New in v3.3
     * @category User & User Privacy
     */
    setCurrentUserConsentPreferences(preferences) {
        return __awaiter(this, void 0, void 0, function* () {
            this.contextService.taskQueue.add(() => __awaiter(this, void 0, void 0, function* () {
                Logger_1.default.debug("BEGIN set current User Consent", this.contextService.context);
                yield this.userService.setCurrentUserConsentPreferences(preferences);
                Logger_1.default.debug("END set current User Consent", this.contextService.context);
            }));
        });
    }
    /**
     * Retrieve the current user consent copy used by the {@link AdpAnalytics} instance for its tracking events.
     *
     * @remarks New in v3.1
     * @category User & User Privacy
     */
    getCurrentUserConsentCopy() {
        return __awaiter(this, void 0, void 0, function* () {
            const consentCopy = this.userService.getCurrentUserConsentCopy();
            Logger_1.default.debug("Current User Consent copy", consentCopy, this.contextService.context);
            return consentCopy;
        });
    }
    /**
     * Retrieve the latest unnamed user consent preferences if omitting input `userToken`.
     * Retrieve the latest named user consent preferences if specifying input `userToken`.
     * If the input `userToken` is invalid, returns `undefined`.
     *
     * This method does not alter the current user nor their user consent preferences associated with the {@link AdpAnalytics} instance.
     * Requires {@link load} to be called first.
     *
     * @param userToken - User Oxygen token, omit for unnamed user
     *
     * @remarks Changed in v3.1
     * @category User & User Privacy
     */
    getUserConsentPreferences(userToken) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.loadCalled) {
                Logger_1.default.error(Common_1.ERROR_MESSAGE.adpNotLoaded);
                return new Error(Common_1.ERROR_MESSAGE.adpNotLoaded);
            }
            const tokenInfo = yield this.userService.parseTokenInfo(userToken);
            if (tokenInfo instanceof Error) {
                Logger_1.default.error(tokenInfo.message);
                return tokenInfo;
            }
            const preferences = this.userService.getUserConsentPreferences(tokenInfo);
            Logger_1.default.debug("User Consent", tokenInfo === null || tokenInfo === void 0 ? void 0 : tokenInfo.userId, preferences);
            return preferences;
        });
    }
    /**
     * Set the user consent preference to an unnamed user if omitting input `userToken`.
     * Set the user consent preference to the associated user token if specifying input `userToken`.
     * Requires {@link load} to be called first.
     *
     * These preferences will be applied to subsequent tracking calls.
     * It will also initialize the user information that will be used by the `UserFacet` object.
     *  - `userToken` is the user Oxygen token.
     *  - If `userToken` is not provided (e.g. empty string or `undefined`),
     *    Web SDK will generate an unnamed user information, and associate the preferences with it instead.
     *    - The unnamed user ID (anonymous ID) will be the `OPTOUTMULTI_REF` cookie if it is available.
     *      Otherwise, a random UUID will be generated instead.
     *    - The generated UUID will be stored in the local storage.
     *    - The anonymous ID will be associated with the product facet provided to {@link load}.
     *
     * Once this method is called, {@link setUserTokenProvider}, {@link setUserConsentDialogBuilder} (deprecated)
     * and their associated callbacks will **cease** to be called by Web SDK.
     *
     * For host and add-on products, each will need to call identify on their own. Web SDK does not provide any means f sharing the user state at the moment.
     *
     * @param preferences - User consent preferences
     * @param userToken - User Oxygen token, omit for unnamed user
     * @returns A promise that resolves an `Error` if {@link load} has not been called
     *
     * @remarks New in v3.1
     * @category User & User Privacy
     */
    setUserConsentPreferences(preferences, userToken) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.loadCalled) {
                Logger_1.default.error(Common_1.ERROR_MESSAGE.adpNotLoaded);
                return new Error(Common_1.ERROR_MESSAGE.adpNotLoaded);
            }
            Logger_1.default.debug("BEGIN set User Consent", this.contextService.context);
            const tokenInfo = yield this.userService.parseTokenInfo(userToken);
            if (tokenInfo instanceof Error) {
                Logger_1.default.error(tokenInfo.message);
                return tokenInfo;
            }
            yield this.userService.loadUser(tokenInfo);
            yield this.userService.saveUserConsentDetectToken(preferences);
            Logger_1.default.debug("END set User Consent", this.contextService.context);
            (_a = this.contextService.context.callback.eventHooks.user_consent) === null || _a === void 0 ? void 0 : _a.forEach((hook) => {
                hook(this.contextService.context);
            });
            return Promise.resolve();
        });
    }
    /**
     * Retrieve the User consent copy which contains the locale-specific texts that can be used to generate the user consent dialog.
     * Requires {@link load} to be called first since the payload is locale specific.
     * If the product locale is unspecified, the Web SDK defaults to the window locale or `en` if there are issues.
     *
     * @remarks Changed in v3.1
     * @category User & User Privacy
     */
    getUserConsentCopy() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.loadCalled) {
                Logger_1.default.error(Common_1.ERROR_MESSAGE.adpNotLoaded);
                return new Error(Common_1.ERROR_MESSAGE.adpNotLoaded);
            }
            const consentCopy = this.userService.getUserConsentCopy();
            Logger_1.default.debug("User Consent copy", consentCopy);
            return consentCopy;
        });
    }
    /**
     * Adds the user information to the {@link AdpAnalytics} instance and sends a `IDENTIFY_USER` event with current logged-in user info to ASE services.
     * Optionally provide and object of additional data to attach to the user facet for all events.
     * Currently, only `intent` for the `user_intent` field in the user facet is available.
     *
     * User Oxygen token needs to be provided by {@link setUserConsentPreferences}.
     *
     * If Web SDK is unable to get a valid user token, an anonymous user ID will be used instead. Web SDK will first check if
     * the `OPTOUTMULTI_REF` cookie is available. If it is available, its value will be used as the anonymous user ID, other Web
     * SDK will generate a UUID in the LocalStorage. This anonymous user ID is associated with the product info provided in
     * the {@link load} and will persist indefinite util the local storage is cleared. An anonymous user have `cookie` for
     * their `provider_name` in the user facet if the cookie is used, otherwise, it will be set to `web_sdk`.
     *
     * If {@link identify} is called after an anonymous user ID is generated, and after the user logs in, the events will contain
     * the alias facet, where `alias_new_id` is the logged-in user ID and `alias_previous_id` is the anonymous user ID.
     *
     * If you are only using {@link setUserTokenProvider} and/or {@link setUserConsentDialogBuilder}, then {@link identify} is
     * mandatory to be called after {@link load} to set up the user and user consent.
     *
     * For host and add-on products, each will need to call identify on their own. Web SDK does not provide any means f sharing the user state at the moment.
     *
     * @param options - Additional data to be included in the identify event.
     * @param options.intent
     * Sets the user intent field in the user facet.
     * Overwrites the existing value.
     * Omitting or having its value as undefined will set the field to undefined.
     * Changing the user will also reset the value to undefined.
     *
     * @remarks Changed in v3.6
     * @category Tracking
     */
    identify(options) {
        Logger_1.default.debug("QUEUE identify()");
        this.contextService.taskQueue
            .add(() => __awaiter(this, void 0, void 0, function* () {
            yield this.userService.setup(true);
            yield this.userService.setUserIntent(options === null || options === void 0 ? void 0 : options.intent);
            const result = yield this.sendEvent("IDENTIFY_USER");
            if (result instanceof UserService_1.NoConsentError) {
                Logger_1.default.debug("Can't send identify event, will try later after User Consent changed");
                this.userService.pushConsentChangedEventQueue(["IDENTIFY_USER", undefined]);
            }
        }))
            .then(() => Logger_1.default.debug("FINISH identify()"));
    }
    /**
     * Displays the user consent dialog. This should be used in two scenarios:
     * - For new users who have not yet given consent.
     * - For users who want to change their consent preferences.
     *
     * If no custom `buildUserConsentDialog` is provided by {@link setUserConsentDialogBuilder} (deprecated), the Web SDK will display a built-in dialog (supported from v3.6.0).
     * User Consent Preferences should be present in the context.
     * If not, remember to call {@link loadUserConsentPreferences}.
     *
     * Note:
     * - If {@link loadUserConsentPreferences} is not called or returns an error,
     *   and you still call {@link loadUserConsentPreferences}, the Consent Dialog will not be shown & an unexpected error will be thrown.
     * - If you don't want to call {@link loadUserConsentPreferences} again or lose track of that method's result,
     *   you can call {@link loadUserConsentPreferences}, which does not hit the server,
     *   to check if User Preferences are in the context before calling {@link showUserConsentDialog}.
     *
     * @remarks
     * - Changed in v3.6
     * - Documentation updated in v3.7.1
     * @category User & User Privacy
     */
    showUserConsentDialog() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.userConsentDialog.showUserConsentDialog();
        });
    }
    /**
     *  Indicate that your product is a host product, not a component or add-in. Use it only when your product includes a child component or add-in.
     *  @category Configuration
     */
    setHostProduct() {
        var _a;
        if (((_a = this.contextService.context.facets.product) === null || _a === void 0 ? void 0 : _a.id) != null) {
            (0, SetHostProduct_1.setHostProduct)({
                product_id: this.contextService.context.facets.product.id,
                session_id: this.contextService.context.session_id,
            }, (component) => __classPrivateFieldGet(this, _AdpAnalytics_instances, "m", _AdpAnalytics_addNewComponent).call(this, component));
        }
        return this;
    }
}
_AdpAnalytics_instances = new WeakSet(), _AdpAnalytics_autoCapturePageIfNeeded = function _AdpAnalytics_autoCapturePageIfNeeded() {
    if (!this.contextService.context.config.captureDocumentClickEvents)
        return;
    if (this.contextService.context.pageAutoCaptured)
        return;
    // On page loaded, this will be false
    this.contextService.context.pageAutoCaptured = true;
    const element = document.querySelector(`meta[${Common_1.HTML_ATTR_CAPTURE_PAGE}]`);
    if (!element)
        return;
    const _a = element.dataset, { adpPageName, adpPageCategory } = _a, data = __rest(_a, ["adpPageName", "adpPageCategory"]);
    const prefix = "adpPageProperty";
    const properties = Object.entries(data).reduce((dict, [key, value]) => {
        if (key.startsWith(prefix) && value != null) {
            return Object.assign(Object.assign({}, dict), { 
                // remove adpProperty prefix and revert first
                [`${key.charAt(prefix.length).toLowerCase()}${key.substring(prefix.length + 1)}`]: value });
        }
        return dict;
    }, undefined);
    if (!adpPageName)
        return;
    if (adpPageCategory) {
        this.page(adpPageCategory, adpPageName, properties);
        return;
    }
    this.page(adpPageName, properties);
}, _AdpAnalytics_postEventHook = function _AdpAnalytics_postEventHook() {
    __classPrivateFieldGet(this, _AdpAnalytics_instances, "m", _AdpAnalytics_autoCapturePageIfNeeded).call(this);
}, _AdpAnalytics_postEventHookByEventType_get = function _AdpAnalytics_postEventHookByEventType_get() {
    return {
        SESSION_START: () => {
            this.sessionService.trackTimestamp = Date.now();
        },
    };
}, _AdpAnalytics_setupSession = function _AdpAnalytics_setupSession() {
    this.sessionService
        .on(SessionService_1.SessionServiceEventType.EXPIRED, (event) => __awaiter(this, void 0, void 0, function* () {
        const { detail } = event;
        if (detail.sessionStartAt) {
            this.contextService.session = detail.id;
            yield this.sendEventInQueue("SESSION_END");
        }
    }))
        .startSession();
    Logger_1.default.debug("END Setup Session", { context: this.contextService.context });
}, _AdpAnalytics_setUpContext = function _AdpAnalytics_setUpContext(product) {
    return __awaiter(this, void 0, void 0, function* () {
        yield this.contextService.setup(product);
    });
}, _AdpAnalytics_setupFacetFilterIfEnabled = function _AdpAnalytics_setupFacetFilterIfEnabled() {
    return __awaiter(this, void 0, void 0, function* () {
        if (!this.contextService.context.config.facetBasedFiltering) {
            return;
        }
        yield this.facetFilterService.setup();
        Logger_1.default.debug("END Setup Filter", this.contextService.context);
    });
}, _AdpAnalytics_setupUser = function _AdpAnalytics_setupUser() {
    return __awaiter(this, void 0, void 0, function* () {
        yield this.userService.setup(false);
    });
}, _AdpAnalytics_setupGeoIfEnable = function _AdpAnalytics_setupGeoIfEnable() {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, void 0, function* () {
        if (!this.contextService.context.config.geoData) {
            return;
        }
        if (((_b = (_a = this.contextService.context.facets) === null || _a === void 0 ? void 0 : _a.geo) === null || _b === void 0 ? void 0 : _b.lat) != null && ((_d = (_c = this.contextService.context.facets) === null || _c === void 0 ? void 0 : _c.geo) === null || _d === void 0 ? void 0 : _d.lon) != null) {
            return;
        }
        yield new Promise((resolve) => {
            navigator.geolocation.getCurrentPosition((position) => {
                this.contextService.context.facets.geo = this.contextService.context.facets.geo || {};
                this.contextService.context.facets.geo.lat = position.coords.latitude;
                this.contextService.context.facets.geo.lon = position.coords.longitude;
                Logger_1.default.debug("Updated geo location", position, "Context", this.contextService.context);
                return resolve(position);
            }, (error) => {
                switch (error.code) {
                    case error.PERMISSION_DENIED:
                        Logger_1.default.warn("User denied the request for geo-location");
                        break;
                    case error.POSITION_UNAVAILABLE:
                        Logger_1.default.warn("Location information is unavailable");
                        break;
                    case error.TIMEOUT:
                        Logger_1.default.warn("The request to get user location timed out");
                        break;
                    default:
                        Logger_1.default.warn("An error without a known error code occurred while requesting geo-location");
                        break;
                }
                return resolve(error);
            });
        });
        Logger_1.default.debug("END Setup Geo", this.contextService.context);
    });
}, _AdpAnalytics_setupHostProductInfoIfEnable = function _AdpAnalytics_setupHostProductInfoIfEnable() {
    return __awaiter(this, void 0, void 0, function* () {
        const { context } = this.contextService;
        if (!context.config.hostProductData) {
            return;
        }
        const hostProduct = yield (0, SetHostProduct_1.getHostProduct)({
            name: context.facets.product.name,
            id: context.facets.product.id,
            version: context.facets.product.build_id,
        });
        if (hostProduct) {
            context.facets.product.meta = Object.assign(Object.assign({}, context.facets.product.meta), { ADDIN_PARENT_ID: hostProduct.product_id, ADDIN_PARENT_SESSIONID: hostProduct.session_id });
        }
        Logger_1.default.debug("END Setup Host Product", context);
    });
}, _AdpAnalytics_send = function _AdpAnalytics_send(message) {
    return __awaiter(this, void 0, void 0, function* () {
        yield this.restService
            .sendEvent(message, (error) => {
            var _a, _b;
            const errorMessage = error instanceof axios_1.AxiosError && (error.status || ((_a = error.response) === null || _a === void 0 ? void 0 : _a.status))
                ? `ADP event wasn't delivered properly, http status code: ${error.status || ((_b = error.response) === null || _b === void 0 ? void 0 : _b.status)}`
                : error.message;
            Logger_1.default.debug("An issue occurred sending event with data=", message, "and response=", error);
            Logger_1.default.warn(errorMessage);
        })
            .then((response) => {
            Logger_1.default.debug("Successfully sent network request", response);
        })
            .catch(() => {
            // Catch abort error to do nothing and fail silently to avoid stopping the promise queue
            // Error is already logged in the catch block
        });
    });
}, _AdpAnalytics_trackLinkFormArgs = function _AdpAnalytics_trackLinkFormArgs(elementType, elementClass, args) {
    var _a;
    let element;
    let name;
    let id;
    let attributes;
    Logger_1.default.debug("Track", elementType, args);
    if ((0, superstruct_1.is)(args, (0, superstruct_1.tuple)([(0, superstruct_1.instance)(elementClass), (0, superstruct_1.string)(), (0, superstruct_1.optional)((0, superstruct_1.record)((0, superstruct_1.string)(), (0, superstruct_1.string)()))]))) {
        [element, name, attributes] = args;
    }
    else if ((0, superstruct_1.is)(args, (0, superstruct_1.tuple)([
        (0, superstruct_1.instance)(elementClass),
        (0, superstruct_1.string)(),
        (0, superstruct_1.optional)((0, superstruct_1.string)()),
        (0, superstruct_1.optional)((0, superstruct_1.record)((0, superstruct_1.string)(), (0, superstruct_1.string)())),
    ]))) {
        [element, name, id, attributes] = args;
    }
    else {
        Logger_1.default.error(Common_1.ERROR_MESSAGE.invalidArguments);
        return undefined;
    }
    id = (_a = id !== null && id !== void 0 ? id : element.getAttribute("id")) !== null && _a !== void 0 ? _a : undefined;
    const component = Object.assign(Object.assign(Object.assign({ type: elementType }, (name != null && { name })), (id != null && { id })), (attributes != null && { attributes }));
    return [element, component];
}, _AdpAnalytics_parsePageArgs = function _AdpAnalytics_parsePageArgs(...args) {
    const overloadWithoutCategory = (0, superstruct_1.tuple)([(0, superstruct_1.string)(), (0, superstruct_1.optional)((0, superstruct_1.record)((0, superstruct_1.string)(), (0, superstruct_1.string)()))]);
    const overloadWithCategory = (0, superstruct_1.tuple)([(0, superstruct_1.string)(), (0, superstruct_1.string)(), (0, superstruct_1.optional)((0, superstruct_1.record)((0, superstruct_1.string)(), (0, superstruct_1.string)()))]);
    let name;
    let category;
    let properties;
    if ((0, superstruct_1.is)(args, overloadWithCategory)) {
        [category, name, properties] = args;
    }
    else if ((0, superstruct_1.is)(args, overloadWithoutCategory)) {
        [name, properties] = args;
    }
    else {
        Logger_1.default.error(Common_1.ERROR_MESSAGE.invalidArguments);
        return undefined;
    }
    const facet = {
        name,
    };
    if (category) {
        facet.category = category;
    }
    if (properties && Object.keys(properties).length > 0) {
        facet.properties = Object.assign({}, properties);
    }
    return facet;
}, _AdpAnalytics_addNewComponent = function _AdpAnalytics_addNewComponent(component) {
    var _a;
    if (((_a = this.contextService.context.facets.product) === null || _a === void 0 ? void 0 : _a.components) == null) {
        this.contextService.context.facets.product.components = [];
    }
    const componentInArray = this.contextService.context.facets.product.components.find(({ name, id, version }) => component.name === name && component.id === id && component.version === version);
    if (componentInArray === undefined) {
        this.contextService.context.facets.product.components = [
            ...this.contextService.context.facets.product.components,
            component,
        ];
    }
};
__decorate([
    (0, Logger_1.logApi)()
], AdpAnalytics.prototype, "setDeviceId", null);
__decorate([
    (0, Logger_1.logApi)()
], AdpAnalytics.prototype, "enableDebug", null);
__decorate([
    (0, Logger_1.logApi)()
], AdpAnalytics.prototype, "setEnv", null);
__decorate([
    (0, Logger_1.logApi)()
], AdpAnalytics.prototype, "enableAutoCaptureClickEvents", null);
__decorate([
    (0, Logger_1.logApi)()
], AdpAnalytics.prototype, "enableFacetBasedFiltering", null);
__decorate([
    (0, Logger_1.logApi)()
], AdpAnalytics.prototype, "enableGeoData", null);
__decorate([
    (0, Logger_1.logApi)()
], AdpAnalytics.prototype, "enableHostProductData", null);
__decorate([
    (0, Logger_1.logApi)()
], AdpAnalytics.prototype, "disableSendEvent", null);
__decorate([
    (0, Logger_1.logApi)()
], AdpAnalytics.prototype, "setSessionTimeout", null);
__decorate([
    (0, Logger_1.logApi)()
], AdpAnalytics.prototype, "setSessionId", null);
__decorate([
    (0, Logger_1.logApi)()
], AdpAnalytics.prototype, "disableDebug", null);
__decorate([
    (0, Logger_1.logApi)()
], AdpAnalytics.prototype, "disableGeoData", null);
__decorate([
    (0, Logger_1.logApi)()
], AdpAnalytics.prototype, "disableHostProductData", null);
__decorate([
    (0, Logger_1.logApi)()
], AdpAnalytics.prototype, "enableSendEvent", null);
__decorate([
    (0, Logger_1.logApi)()
], AdpAnalytics.prototype, "setUserTokenProvider", null);
__decorate([
    (0, Logger_1.logApi)()
], AdpAnalytics.prototype, "setUserConsentDialogBuilder", null);
__decorate([
    (0, Logger_1.logApi)()
], AdpAnalytics.prototype, "setProductReferrer", null);
__decorate([
    (0, Logger_1.logApi)()
], AdpAnalytics.prototype, "getURLWithProductReferrer", null);
__decorate([
    (0, Logger_1.logApi)()
], AdpAnalytics.prototype, "getDeviceId", null);
__decorate([
    (0, Logger_1.logApi)()
], AdpAnalytics.prototype, "on", null);
__decorate([
    (0, Logger_1.logApi)()
], AdpAnalytics.prototype, "loadUserConsentPreferences", null);
__decorate([
    (0, Logger_1.logApi)()
], AdpAnalytics.prototype, "load", null);
__decorate([
    (0, Logger_1.logApi)()
], AdpAnalytics.prototype, "onReady", null);
__decorate([
    (0, Logger_1.logApi)()
], AdpAnalytics.prototype, "onIdle", null);
__decorate([
    (0, Logger_1.logApi)()
], AdpAnalytics.prototype, "trackLink", null);
__decorate([
    (0, Logger_1.logApi)()
], AdpAnalytics.prototype, "trackForm", null);
__decorate([
    (0, Logger_1.logApi)()
], AdpAnalytics.prototype, "track", null);
__decorate([
    (0, Logger_1.logApi)()
], AdpAnalytics.prototype, "page", null);
__decorate([
    (0, Logger_1.logApi)()
], AdpAnalytics.prototype, "group", null);
__decorate([
    (0, Logger_1.logApi)()
], AdpAnalytics.prototype, "entitlement", null);
__decorate([
    (0, Logger_1.logApi)()
], AdpAnalytics.prototype, "retrieveUserToken", null);
__decorate([
    (0, Logger_1.logApi)()
], AdpAnalytics.prototype, "getCurrentUserConsentPreferences", null);
__decorate([
    (0, Logger_1.logApi)()
], AdpAnalytics.prototype, "setCurrentUserConsentPreferences", null);
__decorate([
    (0, Logger_1.logApi)()
], AdpAnalytics.prototype, "getCurrentUserConsentCopy", null);
__decorate([
    (0, Logger_1.logApi)()
], AdpAnalytics.prototype, "getUserConsentPreferences", null);
__decorate([
    (0, Logger_1.logApi)()
], AdpAnalytics.prototype, "setUserConsentPreferences", null);
__decorate([
    (0, Logger_1.logApi)()
], AdpAnalytics.prototype, "getUserConsentCopy", null);
__decorate([
    (0, Logger_1.logApi)()
], AdpAnalytics.prototype, "identify", null);
__decorate([
    (0, Logger_1.logApi)()
], AdpAnalytics.prototype, "showUserConsentDialog", null);
__decorate([
    (0, Logger_1.logApi)()
], AdpAnalytics.prototype, "setHostProduct", null);
exports.AdpAnalytics = AdpAnalytics;
/**
 * Create a Web SDK {@link AdpAnalytics} instance.
 */
const Adp = () => {
    const contextService = new ContextService_1.ContextService();
    const cookieService = new CookieService_1.CookieService();
    const restService = new RestService_1.RestService(contextService);
    const localDataService = new LocalDataService_1.LocalDataService(contextService);
    const sessionService = new SessionService_1.SessionService(contextService, localDataService);
    const facetFilterService = new FacetFilterService_1.FacetFilterService(contextService, restService);
    const userService = new UserService_1.UserService(contextService, localDataService, restService, cookieService);
    const messageBuilderService = new MessageBuilderService_1.MessageBuilderService(contextService, facetFilterService, userService);
    const clickCaptureService = new ClickCaptureService_1.ClickCaptureService(contextService);
    const userConsentDialogService = new UserConsentDialogService_1.UserConsentDialogService(contextService, userService);
    const tracker = new AdpAnalytics(contextService, facetFilterService, userService, messageBuilderService, sessionService, restService, clickCaptureService, userConsentDialogService);
    contextService.tracker = tracker;
    return tracker;
};
exports.Adp = Adp;
